import React from 'react'
import Project from './Project'
import './protfilio.css'

const Protfilio = () => {
    let projectInfo =[
        {
            id:0,
            name:"Tourist Point",
            dese:"Discover new horizons with our Tourist Point application, guiding you to hidden gems and popular destinations. Find your next adventure effortlessly.",
            github:"https://github.com/nazmul-rdo/Tourist-React-JS",
            view:"tourist-react-js.netlify.app",
        },
        {
            id:1,
            name:"Weather App",
            dese:"Stay informed with our Weather App, offering real-time forecasts and weather updates. Plan your days with precision and never be caught off guard by the elements.!",
            github:"https://github.com/nazmul-rdo/Weather-app",
            view:"https://weatherrdo.netlify.app/",
        },
        {
            id:2,
            name:"E-Shop",
            dese:"Experience seamless online shopping at our E-Shop platform. Browse a wide range of products, from trendy fashion to cutting-edge electronics, all in one convenient place.",
            github:"https://github.com/nazmul-rdo/E-commerce-react-js",
            view:"https://eshop-rdo.netlify.app/"
        },
        {
            id:3,
            name:"Coffeelab",
            dese:"Engage in meaningful conversations with our Custom Chat App, designed for personalized communication experiences. Connect with ease and express yourself freely.",
            github:"https://github.com/nazmul-rdo/Coffeelab",
            view:"coffeelab-rdo.netlify.app/"
        },
        {
            id:4,
            name:"RDO-Keeper",
            dese:" Streamline loan management processes with RDO-Keeper, a comprehensive system for tracking and organizing financial transactions. Simplify your financial tasks effortlessly.",
            github:"https://github.com/nazmul-rdo/RDO-Keeper",
            view:"rdokeeper.netlify.app"
        },
       
    ]
    return (
        <section id='protfilio'>
            <div className="container">
                <div className="skill-heading">
                    <h2>My Protfilio</h2>
                </div>
                <div className="Protfilio-container">
                    <div className="portfolio-items">
                        {projectInfo.map((project)=>(
                            <Project key={project.id} project={project} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Protfilio